"use client";
import { useIsMobile } from "@/hooks/use-is-mobile";
import { useLocale } from "@/context/LocaleContext";
import { I18nData } from "@/types/i18n";
import InfoBox from "./info-box";
import AdditionalInfo from "./additional-info-box/additional-info-box";
import Search from "./search/search";

interface TopSectionProps {
  i18nData?: I18nData;
}

export default function TopSection({ i18nData }: TopSectionProps) {
  const isMobile = useIsMobile();
  const { locale } = useLocale();
  const infoBoxHtml = i18nData?.[locale]?.info_box?.replace(/<p>(\s|&nbsp;|<br\s*\/?>)*<\/p>/gi, "").trim();
  const additionalInfoHtml = i18nData?.[locale]?.additional_info?.replace(/<p>(\s|&nbsp;|<br\s*\/?>)*<\/p>/gi, "").trim();

  const InfoBoxes = (
    <div id="infoWrapper">
      {infoBoxHtml && <InfoBox infoBoxHtml={infoBoxHtml} />}
      {additionalInfoHtml && <AdditionalInfo additionalInfoHtml={additionalInfoHtml} />}
    </div>
  );

  return (
    <div id="topSection">
      {isMobile ? (
        <>
          {InfoBoxes}
          <Search i18nData={i18nData} />
        </>
      ) : (
        <>
          <Search i18nData={i18nData} />
          {InfoBoxes}
        </>
      )}
    </div>
  );
}
